import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from '@angular/common';
import { WebcamModule } from "ngx-webcam";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { StructureSharedModule } from "./structure-shared/structure-shared.module";
import { OnboardingModule } from "./onboarding/onboarding.module";
import { SharedModule } from "./shared/shared.module";
import { ExistingCustomerModule } from "./existing-customer/existing-customer.module";

import { NgxMaskModule, IConfig } from "ngx-mask";
import { NgOtpInputModule } from 'ng-otp-input';
import { MatSliderModule } from '@angular/material/slider';
// import { NgxEncryptCookieService } from 'ngx-encrypt-cookie';
import { CookieService } from 'ngx-cookie-service';
// import { InputOtpModule } from 'primeng/inputotp';


// import { MatDatepickerModule } from "@angular/material/datepicker";
// import { MatInputModule } from "@angular/material/input";
// import { MatFormFieldModule } from "@angular/material/form-field";
// import { MatNativeDateModule } from "@angular/material/core";

export const options: Partial<null | IConfig> | (() => Partial<IConfig>) = null;

import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoginComponent } from "./login/login.component";
import { NgxSliderModule } from '@angular-slider/ngx-slider';


import { RoundProgressModule } from "angular-svg-round-progressbar";
import { NgxSpinnerModule } from "ngx-spinner";
import { BaseClassService } from "./onboarding/interceptors/base-class.service";
import { ClipboardModule, ClipboardService } from "ngx-clipboard";
import { DesignSprintComponent } from './design-sprint/design-sprint.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardCreditCardsComponent } from './dashboard-credit-cards/dashboard-credit-cards.component';
import { DashboardLoansComponent } from './dashboard-loans/dashboard-loans.component';
import { BranchLocatorComponent } from './branch-locator/branch-locator.component';
import { PayCardComponent } from './pay-card/pay-card.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { StopCardComponent } from "./stop-card/stop-card.component";
import { ChangeCardPinComponent } from "./change-card-pin/change-card-pin.component";
import { LoanNicknameComponent } from './loan-nickname/loan-nickname.component';
import { CardNickNameComponent } from './card-nick-name/card-nick-name.component';
import { ChangePinComponent } from './change-pin/change-pin.component';
import { PayCardSuccessComponent } from './pay-card-success/pay-card-success.component';
import { PayCardSuspendedComponent } from '../app/pay-card-suspended/pay-card-suspended.component';
import { QuickPaymentComponent } from './quick-payment/quick-payment.component';
import { DatePipe } from "@angular/common";
import { PayCardErrorComponent } from './pay-card-error/pay-card-error.component';
import { CardTransactionHistoryComponent } from './card-transaction-history/card-transaction-history.component';
import { LoanPaymentHistoryComponent } from './loan-payment-history/loan-payment-history.component';
import { MonthSelectComponent } from './month-select/month-select.component';
import { ImtiazVerificationModule } from "./imtiaz-verification/imtiaz-verification.module";
import { AmountFormatterPipe } from './pipes/amount-formatter.pipe';
import { LoyaltyPointsComponent } from './loyalty-points/loyalty-points.component';
import { LoyaltyPointsRadeemComponent } from './loyalty-points-radeem/loyalty-points-radeem.component';
import { LoyaltyPointsRadeemConfirmComponent } from './loyalty-points-radeem-confirm/loyalty-points-radeem-confirm.component';
import { LoyaltyPointsRadeemSuccesComponent } from './loyalty-points-radeem-succes/loyalty-points-radeem-succes.component';
import { CardReplacementSuccessComponent } from './card-replacement-success/card-replacement-success.component';

import { SettingsComponent } from './settings/settings.component';
import { SettingsUpdateEmailComponent } from './settings-update-email/settings-update-email.component';
import { SettingsUpdateMobileNumberComponent } from './settings-update-mobile-number/settings-update-mobile-number.component';
import { InboxComponent } from './inbox/inbox.component';
import { CardLimitPermanentComponent } from './card-limit-permanent/card-limit-permanent.component';
import { CardLimitTemporaryComponent } from './card-limit-temporary/card-limit-temporary.component';
import { CardUploadDocumentComponent } from './card-upload-document/card-upload-document.component';
import { CardLimitSuccessComponent } from './card-limit-success/card-limit-success.component';
import { CardLimitDeclineComponent } from "./card-limit-decline/card-limit-decline.component";
import { ReachUsComponent } from './reach-us/reach-us.component';
import { FeedbacksComponent } from './feedbacks/feedbacks.component';
import { FeedbackSuccessComponent } from './feedback-success/feedback-success.component';
import { TypeOfProductComponent } from './type-of-product/type-of-product.component';
import { SelectPaymentMethodComponent } from './select-payment-method/select-payment-method.component';
import { TypeOfPayComponent } from './type-of-pay/type-of-pay.component';
import { ConfirmPinComponent } from './existing-customer/confirm-pin/confirm-pin.component';
import { EnterEmailComponent } from './existing-customer/enter-email/enter-email.component';
import { PayCardReviewComponent } from './pay-card-review/pay-card-review.component';
import { CardRequestSupplementaryComponent } from './card-request-supplementary/card-request-supplementary.component';
import { CardRequestVerifyYourselfComponent } from './card-request-verify-yourself/card-request-verify-yourself.component';
import { CardRequestUploadIdComponent } from './card-request-upload-id/card-request-upload-id.component';
import { CardRequestConfrimDetailsComponent } from './card-request-confrim-details/card-request-confrim-details.component';
import { CardRequestLimitSettingComponent } from './card-request-limit-setting/card-request-limit-setting.component';
import { CardRequestPhysicalCardComponent } from './card-request-physical-card/card-request-physical-card.component';
import { CardRequestNameAppearComponent } from './card-request-name-appear/card-request-name-appear.component';
import { CardRequestLettersComponent } from './card-request-letters/card-request-letters.component';
import { PayLoanSuccessComponent } from './pay-loan-success/pay-loan-success.component';
import { LoanDeferInstalmentComponent } from './loan-defer-instalment/loan-defer-instalment.component';
import { LoanDeferUploadDocComponent } from './loan-defer-upload-doc/loan-defer-upload-doc.component';
import { LoanReviewSuccessComponent } from './loan-review-success/loan-review-success.component';
import { SettingManageAddressComponent } from './setting-manage-address/setting-manage-address.component';
import { SettingEditPrimaryEmailComponent } from './setting-edit-primary-email/setting-edit-primary-email.component';
import { SettingPushNotificationsComponent } from './setting-push-notifications/setting-push-notifications.component';
import { RewardsLoyaltyPointsComponent } from './rewards-loyalty-points/rewards-loyalty-points.component';
import { LandingPageOffersComponent } from './landing-page-offers/landing-page-offers.component';
import { LandingPageMyFavouritesComponent } from './landing-page-my-favourites/landing-page-my-favourites.component';
import { LandingPageOfferDetailsComponent } from './landing-page-offer-details/landing-page-offer-details.component';
import { InsuranceComponent } from './insurance/insurance.component';
import { InsuranceAssistanceComponent } from './insurance-assistance/insurance-assistance.component';
import { InsuranceClaimsComponent } from './insurance-claims/insurance-claims.component';
import { InsuranceBenefitsDocumentsComponent } from './insurance-benefits-documents/insurance-benefits-documents.component';
import { InsurancrNickComponent } from './insurancr-nick/insurancr-nick.component';
import { EnterMobilePinComponent } from './enter-mobile-pin/enter-mobile-pin.component';
import { BranchTicketIssuedComponent } from './branch-ticket-issued/branch-ticket-issued.component';
import { CardPageComponent } from './card-page/card-page.component';
import { PayCardFailedComponent } from './pay-card-failed/pay-card-failed.component';
import { ChangeCardPinConfirmComponent } from './change-card-pin-confirm/change-card-pin-confirm.component';
import { ChangeCardPinSinnadComponent } from './change-card-pin-sinnad/change-card-pin-sinnad.component';
import { EmailOtpVerifyComponent } from './email-otp-verify/email-otp-verify.component';
import { MobileOtpVerifyComponent } from './mobile-otp-verify/mobile-otp-verify.component';
import { ChangeCardPinSinnadSuccessComponent } from './change-card-pin-sinnad-success/change-card-pin-sinnad-success.component';
import { ReachUsPageComponent } from './reach-us-page/reach-us-page.component';
import { SuccessPaymentComponent } from './success-payment/success-payment.component';
import { PasswordComponent } from './password/password.component';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { VerifyEmailMobileComponent } from './verify-email-mobile/verify-email-mobile.component';
import { SelectServiceComponent } from './select-service/select-service.component';
import { PaymentSuccessfulComponent } from './payment-successful/payment-successful.component';
import { EKeyFailedComponent } from './e-key-failed/e-key-failed.component';
import { SuccessComponent } from './success/success.component';
import { FailureComponent } from './failure/failure.component';


import { provideHttpClient } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';

import { CarouselModule } from 'ngx-owl-carousel-o';

// Factory function — no arguments at all
export function HttpLoaderFactory() {
  return new TranslateHttpLoader();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DesignSprintComponent,
    DashboardComponent,
    DashboardCreditCardsComponent,
    DashboardLoansComponent,
    BranchLocatorComponent,
    PayCardComponent,
    LandingPageComponent,
    StopCardComponent,
    ChangeCardPinComponent,
    LoanNicknameComponent,
    CardNickNameComponent,
    ChangePinComponent,
    PayCardSuccessComponent,
    PayCardSuspendedComponent,
    QuickPaymentComponent,
    PayCardErrorComponent,
    CardTransactionHistoryComponent,
    LoanPaymentHistoryComponent,
    MonthSelectComponent,
    AmountFormatterPipe,
    LoyaltyPointsComponent,
    LoyaltyPointsRadeemComponent,
    LoyaltyPointsRadeemConfirmComponent,
    LoyaltyPointsRadeemSuccesComponent,
    CardReplacementSuccessComponent,
    SettingsComponent,
    SettingsUpdateEmailComponent,
    SettingsUpdateMobileNumberComponent,
    InboxComponent,
    CardLimitPermanentComponent,
    CardLimitTemporaryComponent,
    CardUploadDocumentComponent,
    CardLimitSuccessComponent,
    CardLimitDeclineComponent,
    ReachUsComponent,
    FeedbacksComponent,
    FeedbackSuccessComponent,
    TypeOfProductComponent,
    SelectPaymentMethodComponent,
    TypeOfPayComponent,
    ConfirmPinComponent,
    EnterEmailComponent,
    PayCardReviewComponent,
    CardRequestSupplementaryComponent,
    CardRequestVerifyYourselfComponent,
    CardRequestUploadIdComponent,
    CardRequestConfrimDetailsComponent,
    CardRequestLimitSettingComponent,
    CardRequestPhysicalCardComponent,
    CardRequestNameAppearComponent,
    CardRequestLettersComponent,
    PayLoanSuccessComponent,
    LoanDeferInstalmentComponent,
    LoanDeferUploadDocComponent,
    LoanReviewSuccessComponent,
    SettingManageAddressComponent,
    SettingEditPrimaryEmailComponent,
    SettingPushNotificationsComponent,
    RewardsLoyaltyPointsComponent,
    LandingPageOffersComponent,
    LandingPageMyFavouritesComponent,
    LandingPageOfferDetailsComponent,
    InsuranceComponent,
    InsuranceAssistanceComponent,
    InsuranceClaimsComponent,
    InsuranceBenefitsDocumentsComponent,
    InsurancrNickComponent,
    EnterMobilePinComponent,
    BranchTicketIssuedComponent,
    CardPageComponent,
    PayCardFailedComponent,
    ChangeCardPinConfirmComponent,
    ChangeCardPinSinnadComponent,
    EmailOtpVerifyComponent,
    MobileOtpVerifyComponent,
    ChangeCardPinSinnadSuccessComponent,
    ReachUsPageComponent,
    SuccessPaymentComponent,
    PasswordComponent,
    CreatePasswordComponent,
    VerifyEmailMobileComponent,
    SelectServiceComponent,
    PaymentSuccessfulComponent,
    EKeyFailedComponent,
    SuccessComponent,
    FailureComponent,

  ],
  imports: [
    NgxMaskModule.forRoot(),
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    StructureSharedModule,
    ExistingCustomerModule,
    ImtiazVerificationModule,
    OnboardingModule,
    NgxSpinnerModule,
    SharedModule,
    WebcamModule,
    NgxSliderModule,
    MatSliderModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      timeOut: 300000,
      positionClass: "toast-top-center",
      preventDuplicates: true,
      closeButton: true,
    }),
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    RoundProgressModule,
    NgOtpInputModule,
    CarouselModule
    // MatFormFieldModule,
    // MatInputModule,
    // MatDatepickerModule,
    // MatNativeDateModule
  ],
  providers: [
    AmountFormatterPipe,
    CookieService,
    DatePipe,
    provideHttpClient(),
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: './assets/i18n/',
        suffix: '.json'
      }
    },
        {
      provide: HTTP_INTERCEPTORS,
      useClass: BaseClassService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
